
import { PropType } from 'vue';
import { mapActions, mapGetters } from 'vuex';
import mMap from '../../molecules/Map.vue';
import { MAX_BOUNDS } from '../../../constants/search.const';
import Api from '../../../functions/api';
import { EventBus } from '../../../functions/eventBus';
import MapBroker from '../../../interfaces/mapBroker.interface';
import BrokersMapResponse from '../../../interfaces/responses/brokersMapResponse.interface';
import { SearchMapTexts } from '@/interfaces/searchTexts.interface';

interface Data {
    brokers: MapBroker[];
    initial: boolean;
    isDesktop: boolean;
    maxBounds: { lat: number; lng: number }[];
    userLocationIsChecked: boolean;
}

export default {
    components: {
        mMap,
    },

    props: {
        texts: {
            type: Object as PropType<SearchMapTexts>,
            default: () => ({
                close: '',
                drawArea: '',
                helpTextDesktop: '',
                helpTextMobile: '',
                noResults: '',
                removeArea: '',
                openHouseTeaser: '',
                openHouseTeaserSignup: '',
            }),
        },
    },

    data(): Data {
        return {
            brokers: [],
            initial: true,
            isDesktop: EventBus.isDesktop,
            maxBounds: MAX_BOUNDS,
            userLocationIsChecked: false,
        };
    },

    computed: {
        ...mapGetters({
            activeProperty: 'search/activeProperty',
            area: 'search/area',
            bounds: 'search/bounds',
            fitProperties: 'search/fitProperties',
            latitude: 'search/latitude',
            longitude: 'search/longitude',
            mapIsLoading: 'search/mapIsLoading',
            mapZoom: 'search/mapZoom',
            properties: 'search/mapResults',
            query: 'search/query',
            userLocation: 'search/userLocation',
            zoom: 'search/zoom',
        }),

        polygon(): number[][] {
            return this.area ? this.area : this.bounds;
        },
    },

    watch: {
        bounds(): void {
            this.getBrokers();
        },
    },

    beforeMount(): void {
        EventBus.$on('app.resize', () => {
            this.isDesktop = EventBus.isDesktop;
        });

        // TEMPORARY FIX FOR BUG #20283 IN DEVOPS
        this.userLocationIsChecked = true;
        this.setBounds([]);

        // PLEASE DO NOTE REMOVE BELOW CODE, EVEN IF THE LINTER TELLS YOU TO DO SO
        // THIS IS A TEMPORARY FIX FOR BUG #20283 IN DEVOPS
        // if (this.userLocation) {
        //     if (this.initial) this.setBounds([]);
        //     this.userLocationIsChecked = true;
        // } else {
        //     Location.getCurrentPosition().then((location: Coordinates) => {
        //         this.setUserLocation(location);
        //         if (
        //             location.longitude < this.maxBounds[0].lng
        //             || location.latitude < this.maxBounds[0].lat
        //             || location.longitude > this.maxBounds[1].lng
        //             || location.latitude > this.maxBounds[1].lat
        //         ) {
        //             return;
        //         }

        //         this.setLatitude(location.latitude);
        //         this.setLongitude(location.longitude);
        //         this.setZoom(12);
        //         this.setBounds([]);
        //     }).catch(() => {
        //         this.setBounds([]);
        //     }).finally(() => {
        //         this.userLocationIsChecked = true;
        //     });
        // }
    },

    beforeUnmount(): void {
        EventBus.$off('app.resize');
    },

    methods: {
        ...mapActions({
            setActiveProperty: 'search/setActiveProperty',
            setArea: 'search/setArea',
            setBounds: 'search/setBounds',
            setLatitude: 'search/setLatitude',
            setLongitude: 'search/setLongitude',
            setMapHasInteraction: 'search/setMapHasInteraction',
            setUserLocation: 'search/setUserLocation',
            setZoom: 'search/setZoom',
        }),

        getBrokers(): void {
            Api.getBrokers({
                query: '',
            }).then((response: BrokersMapResponse) => {
                this.brokers = response.results;
            });
        },

        /**
         * Handle "draw" event on map.
         *
         * @param {number[][] | null} value
         * @return {void}
         */
        onDraw(value: number[][] | null): void {
            this.setArea(value ?? []);
        },

        /**
         * Handle "load" event on map.
         *
         * @return {void}
         */
        onLoad({bounds}: {bounds: {_ne: {lat: number, lng: number}, _sw: {lat: number, lng: number}}}): void {
            this.formatAndSetBounds(bounds);
            // User Story 26119: Undersøg mulig reduktion af kald til search
            // this.getBrokers();
        },
        formatAndSetBounds(bounds: {_ne: {lat: number, lng: number}, _sw: {lat: number, lng: number}}){
            const northEast: [number, number] = [
                bounds._ne.lng,
                bounds._ne.lat,
            ];
            const northWest: [number, number] = [
                bounds._sw.lng,
                bounds._ne.lat,
            ];
            const southEast: [number, number] = [
                bounds._ne.lng,
                bounds._sw.lat,
            ];
            const southWest: [number, number] = [
                bounds._sw.lng,
                bounds._sw.lat,
            ];

            this.setBounds([
                southWest,
                southEast,
                northEast,
                northWest,
                southWest,
            ]);
        },
        /**
         * Handle "move" event on map.
         *
         * @param {any} event
         * @return {void}
         */
        onMove(payload: any): void {
            if (this.initial) {
                this.initial = false;
            } else {
                this.setMapHasInteraction(payload.isUserInteraction);
            }

            this.setLatitude(payload.latitude);
            this.setLongitude(payload.longitude);
            this.setZoom(payload.zoom);

            this.formatAndSetBounds(payload.bounds);

        },
    },
};
